import { render, staticRenderFns } from "./ModalKim.vue?vue&type=template&id=4ccf7cc2&scoped=true"
import script from "./ModalKim.vue?vue&type=script&lang=ts"
export * from "./ModalKim.vue?vue&type=script&lang=ts"
import style0 from "./ModalKim.vue?vue&type=style&index=0&id=4ccf7cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf7cc2",
  null
  
)

export default component.exports